<template>
    <g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 7.5C15.5 11.6421 12.1421 15 8 15C3.85786 15 0.5 11.6421 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5ZM11.0893 6.42261C11.4147 6.09717 11.4147 5.56954 11.0893 5.2441C10.7638 4.91866 10.2362 4.91866 9.91074 5.2441L7.16667 7.98818L6.08926 6.91077C5.76382 6.58533 5.23618 6.58533 4.91074 6.91077C4.58531 7.23621 4.58531 7.76384 4.91074 8.08928L6.57741 9.75595C6.73369 9.91223 6.94565 10 7.16667 10C7.38768 10 7.59964 9.91223 7.75592 9.75595L11.0893 6.42261Z" fill="#24A148"/>
    </g>
</template>
<script>
export default {
    name: "CheckCircleGreen",
};
</script>
